import { NgModule } from '@angular/core';
import { FieldErrorMessages } from './field-error-messages.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../../common/directives/directives.module';

@NgModule({
  declarations: [FieldErrorMessages],
  imports: [CommonModule, TranslateModule, DirectivesModule],
  exports: [FieldErrorMessages],
})
export class FieldErrorMessagesModule {}
